export { default } from './MenuSlim'
